import {NgModule} from '@angular/core';
import {NgxSyncScrollComponent} from './ngx-syncscroll/ngx-syncscroll.component';

@NgModule({
  declarations: [NgxSyncScrollComponent],
  exports: [NgxSyncScrollComponent]
})

export class NgxSyncScrollModule {}
